import React from 'react'
import { slice, isEmpty } from 'ramda'
import styles from './ItemListCell.module.scss'

interface ISubTextProps {
  items: string[]
  suffix: string
}

const SubText = ({ items, suffix }: ISubTextProps) => {
  const subText =
    items.length === 1
      ? items[0]
      : items.length === 2
      ? `${items[0]} and ${items[1]}`
      : `${items[0]}, ${items[1]} and ${items.length - 2} ${suffix}`

  return <span className={styles.subtext}>+ {subText}</span>
}
interface IItemListCellProps {
  items: string[]
  suffix?: string
  basic?: boolean
  blankCharacter?: string
}

const ItemListCell = (props: IItemListCellProps) => {
  const { items, suffix = 'others', basic = false, blankCharacter = '' } = props

  const primaryItem = items[0] ? items[0] : blankCharacter
  const secondaryItems = slice(1, items.length, items)

  return (
    <div className={styles.root}>
      <strong>{primaryItem}</strong>
      {!isEmpty(secondaryItems) &&
        (basic ? `+ ${secondaryItems.length} ${suffix}` : <SubText items={secondaryItems} suffix={suffix} />)}
    </div>
  )
}

export default ItemListCell
